import { render, staticRenderFns } from "./product-list-group.vue?vue&type=template&id=42f44683&scoped=true"
import script from "./product-list-group.vue?vue&type=script&lang=js"
export * from "./product-list-group.vue?vue&type=script&lang=js"
import style0 from "./product-list-group.vue?vue&type=style&index=0&id=42f44683&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f44683",
  null
  
)

export default component.exports